import React from 'react';
import {FieldArray} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';
import SurveyConsoleButtonsType from './SurveyConsoleButtonsType';

const SurveyConsoleSettingsForm = () => {
    return (
        <div className="form-group mt-3">
            <h4>&gt; <FormattedMessage {...messages.surveys.form.label.consoleButtons.title} /></h4>
            <FieldArray name="consoleButtons" component={SurveyConsoleButtonsType} />
        </div>
    );
};

export default SurveyConsoleSettingsForm;
